Object.defineProperty(exports,"__esModule",{value:true});exports.default=

{
RESISTANCE_COEF:0.6,



UNCERTAINTY_THRESHOLD:3};


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/lib/constant.js
// module id = 222
// module chunks = 0